/**
 *  @fileOverview Search Results module
 *
 *  @author       Aaron Chapman
 *
 */

function SearchResultsModule () {
  this.init = function () {
    let searchFilters = document.querySelectorAll('.courseSearchResults__filterButton')

    Array.from(searchFilters).forEach(searchFilterButton => {
      searchFilterButton.addEventListener('click', toggleFilter)

      if (window.innerWidth >= 1040) {
        searchFilterButton.classList.toggle('courseSearchResults__filterButton--open')
      }
    })

    if (window.innerWidth >= 1040) {
      let searchAccordions = document.querySelectorAll('.courseSearchResults__selectItems')

      Array.from(searchAccordions).forEach(accordion => {
        accordion.classList.toggle('courseSearchResults__selectItems--show')
      })
    }
  }

  let toggleFilter = function (e) {
    let btn = e.srcElement
    let wrapper = btn.parentElement.parentElement
    let accordion = wrapper.querySelector('.courseSearchResults__selectItems')
    let aria = btn.getAttribute('aria-expanded')

    btn.setAttribute('aria-expanded', aria === 'true' ? 'false' : 'true')
    btn.classList.toggle('courseSearchResults__filterButton--open')
    accordion.classList.toggle('courseSearchResults__selectItems--show')
  }
}

module.exports = SearchResultsModule
